const mediaCoverageConfig = {
  name: 'Media Coverage',
  inputs: [],
};

export default mediaCoverageConfig;
